// test341
(341 && 0);
